export { default } from './OurClientsView';



// WEBPACK FOOTER //
// ./src/components/views/OurClientsView/index.js